import { useMemo } from "react";
import { Linkedin, Facebook, Link as LinkIcon, Check } from "lucide-react";
import { useState } from "react";

// Custom X (Twitter) icon — lucide's Twitter is still the retired bird logo.
const XIcon = ({ className = "" }) => (
  <svg
    viewBox="0 0 24 24"
    aria-hidden="true"
    className={className}
    fill="currentColor"
  >
    <path d="M18.244 2H21l-6.52 7.45L22 22h-6.828l-4.77-6.24L4.8 22H2.043l6.98-7.98L2 2h6.914l4.32 5.71L18.244 2zm-1.194 18h1.61L7.02 4H5.29l11.76 16z" />
  </svg>
);

export const ShareButtons = ({ url, title, description }) => {
  const shareUrl = url || (typeof window !== "undefined" ? window.location.href : "");
  const shareTitle = title || "";
  const shareDesc = description || "";
  const [copied, setCopied] = useState(false);

  const links = useMemo(() => {
    const u = encodeURIComponent(shareUrl);
    const t = encodeURIComponent(shareTitle);
    const d = encodeURIComponent(shareDesc);
    return {
      linkedin: `https://www.linkedin.com/sharing/share-offsite/?url=${u}`,
      x: `https://twitter.com/intent/tweet?url=${u}&text=${t}`,
      facebook: `https://www.facebook.com/sharer/sharer.php?u=${u}&quote=${d || t}`,
    };
  }, [shareUrl, shareTitle, shareDesc]);

  const copy = async () => {
    try {
      await navigator.clipboard.writeText(shareUrl);
      setCopied(true);
      setTimeout(() => setCopied(false), 1800);
    } catch (_) {
      /* ignore */
    }
  };

  const btn =
    "inline-flex items-center justify-center h-9 w-9 rounded-full border border-[var(--line-strong)] text-neutral-700 hover:text-white hover:bg-black hover:border-black transition-colors";

  return (
    <div data-testid="share-buttons" className="flex items-center gap-3">
      <span className="text-[10px] uppercase tracking-[0.3em] text-neutral-400 mr-1">
        Partager
      </span>
      <a
        data-testid="share-linkedin"
        href={links.linkedin}
        target="_blank"
        rel="noopener noreferrer"
        aria-label="Partager sur LinkedIn"
        className={btn}
      >
        <Linkedin className="h-4 w-4" />
      </a>
      <a
        data-testid="share-x"
        href={links.x}
        target="_blank"
        rel="noopener noreferrer"
        aria-label="Partager sur X"
        className={btn}
      >
        <XIcon className="h-3.5 w-3.5" />
      </a>
      <a
        data-testid="share-facebook"
        href={links.facebook}
        target="_blank"
        rel="noopener noreferrer"
        aria-label="Partager sur Facebook"
        className={btn}
      >
        <Facebook className="h-4 w-4" />
      </a>
      <button
        data-testid="share-copy"
        type="button"
        onClick={copy}
        aria-label="Copier le lien"
        className={btn}
      >
        {copied ? <Check className="h-4 w-4 text-[var(--red)]" /> : <LinkIcon className="h-4 w-4" />}
      </button>
    </div>
  );
};
